angular.module('jv.candidate.details.resume.controller',['ngStorage'])
    .controller('jvCandDetailsResumeController', ['$scope', '$http', '$timeout', 'candidates','$window', '$log', '$rootScope', '$localStorage','browserDetails','jvCandResumeModelFactory',
        function($scope, $http, $timeout, candidates, $window, $log, $rootScope, $localStorage,browserDetails,jvCandResumeModelFactory){
            //  this will hold all request urls. declaring it under $scope, so it will be accessible for unit-test cases
            $scope.requestUrls = {
                applicationDetail: '/jhire/action/application/',
                resource: '/jhire/action/resource/',
                popUpFiles: '/jhire/modules/candidates/details/application/'
            };

            $scope.isIEbrowser = false;
            $scope.filePreview = $scope.filePreview || {};

            if($scope.isIE()){
                $scope.isIEbrowser = true;
            }

            $scope.resModel = window.JV.JH.Model.create();

            $scope.clModel = window.JV.JH.Model.create();
            $scope.atchmntModel = window.JV.JH.Model.create();
            $scope.pdfFileName = '';
            $scope.pdfViewerZoom = '#zoom=100';
            $scope.pdfObjectType='';
            $scope.kindMapping = {
                'Resume': 6,
                'CoverLetter': 9,
                'Attachment': 10
            };
            $scope.candForm = {};
            $scope.file = {};
            $scope.pdfIncrementer = 0;

            $scope.files = {}; //Holds all the file upload
            $scope.Resume  = {};
            $scope.CoverLetter = {};
            $scope.Attachment  = {};

            $scope.textarea = {};
        //  $scope.flags.loading = false;

            // Hide the upload panel by default.
            $scope.file.showUploadPanel = false;
            $scope.showUpload = false;

            $scope.resModel.xhr = $http;
            $scope.resModel.scope = $scope;

            $scope.clModel.xhr = $http;
            $scope.clModel.scope = $scope;

            $scope.atchmntModel.xhr = $http;
            $scope.atchmntModel.scope = $scope;

            // Hiding the upload screen (change var name)
            $scope.attachment = {};
            $scope.attachmentIndex = 0;
            $scope.resumeUpload = false;
            $scope.expandUpload = false;
            $scope.expandTextarea = false;
            $scope.uploaderClass = 'actn-collapse';
            $scope.textareaClass = 'actn-expand';
            $scope.response = {};
            $scope.resourceInfo = {};
            $scope.attachmentList = [];
            $scope.fileToDelete = '';
            $scope.removeUploadedFile = false;
            $scope.errors = {};
            $scope.uploadResponse = {};
            $scope.fastRead = false;
            $scope.addFormInfo={};

            $scope.createPreviewUrl = function(file){
                if(file.eid){
                    $scope.filePreview.url = $scope.requestUrls.resource + $scope.params.applicationId + '/file/' + file.eid+ '/print';
                }
            };

            $scope.resModel.postFetch = function(){
                if($scope.resume && $scope.resume.fileSize !== 0){
                    $scope.file = $scope.resume;
                }else{
                    $scope.file = $scope.resume;
                    $scope.file.empty = true;
                }
                if($scope.file.eid){
                    $scope.filePreview.url = $scope.requestUrls.resource + $scope.params.applicationId + '/file/' + $scope.file.eid+ '/print';
                }
                $scope.file.fileKind = 'Resume';
                $scope.file.kind = 'Resume';
                $scope.file.fileType = i18n.RESUME;
                $scope.file.uploadFileType=i18n.JV_CONTACTDETAILS_UPLOAD_RESUME;
                $scope.file.uploadFileTypeReplaceMessage=i18n.I18N_REPLACE_CURRENT_RESUME;

                if($scope.fastRead){
                    $scope.file.readMode = 0;
                    $scope.fastRead = false;
                }

                $scope.resParam = {
                    applicationId : $scope.params.applicationId,
                    fId : angular.copy($scope.file.eid)
                };
                var getParams = {
                    preview: 'true'
                };

                if( $scope.resParam.fName &&  $scope.resParam.fName.substr($scope.resParam.fName.length - 3) !== 'pdf'){
                    $scope.flags.pdfLoading = true;
                    candidates.viewResource($scope.resParam, $.params(getParams), function(){
                        $scope.flags.pdfLoading = false;

                        $scope.viewFile = {
                            eid : angular.copy($scope.file.eid),
                            fileName : angular.copy($scope.file.fileName)
                        };
                    }, function(err){
                        $log.error(err);
                    });
                }else{
                    if($scope.expandUpload && $scope.removeUploadedFile){
                        //This is when we hit delete just after uploading a file .You want to keep the panel open.
                        //$scope.createUploader($scope.file.fileKind);
                        $scope.file.showUploadPanel = true;
                    }
                    $scope.flags.pdfLoading = false;
                }
                $scope.createPreviewUrl($scope.file);
                $scope.setPreview();
            };

            $scope.clModel.postFetch = function(){

                if(!$scope.resume){
                    // Fetching resume on load
                    //only fetch resume first time
                    $scope.resModel.fetch({
                        url: $scope.requestUrls.applicationDetail + $scope.params.applicationId + '/resource/' + $scope.kindMapping['Resume'],
                        sourceKey: 'resourceInfo',
                        destkey: 'resume',
                        data: {
                            readMode: 0
                        }
                    });
                }

                //Post process the cover letter only when fileKind is set.
                //Currently stickiness of tabs is not supported, so only when the tab is clicked
                //should the post processing be done.
                if($scope.file && $scope.file.fileKind === 'CoverLetter') {
                    if($scope.coverletter && $scope.coverletter.fileSize !== 0){
                        $scope.file = $scope.coverletter;
                    }else{
                        $scope.file = $scope.coverletter;
                        $scope.file.empty = true;
                    }
                    if(!$scope.fetchOnLoad){
                        $scope.file.fileKind = 'CoverLetter';
                        $scope.file.kind = 'CoverLetter';
                        $scope.file.fileType = i18n.COVERLETTER;
                        $scope.file.uploadFileType = i18n.JV_CONTACTDETAILS_UPLOAD_COVER_LETTER;
                        $scope.file.uploadFileTypeReplaceMessage=i18n.I18N_REPLACE_CURRENT_COVER_LETTER;
                    }else{
                        //dont set fileKind to avoid setting tab on load for coverletter.
                        $scope.file.fileKind = '';
                        $scope.file.kind = '';
                    }
                    if($scope.fastRead){
                        $scope.file.readMode = 0;
                        $scope.fastRead = false;
                    }

                    $scope.clParam = {
                        applicationId: $scope.params.applicationId,
                        fId: angular.copy($scope.file.eid)
                    };
                    var getParams = {
                        preview: 'true'
                    };

                    if($scope.clParam.fName && $scope.clParam.fName.substr($scope.clParam.fName.length - 3) !== 'pdf'){
                        $scope.flags.pdfLoading = true;
                        candidates.viewResource($scope.clParam, $.params(getParams), function(){
                            $scope.flags.pdfLoading = false;

                            $scope.viewFile = {
                                eid : angular.copy($scope.file.eid),
                                fileName : angular.copy($scope.file.fileName)
                            };

                            if($scope.expandUpload && $scope.removeUploadedFile){
                                //This is when we hit delete just after uploading a file .You want to keep the panel open.

                                $scope.file.showUploadPanel = true;
                            }
                            $scope.setPreview();
                        }, function(err){
                            $log.error(err);
                        });
                    }else{
                        if($scope.expandUpload && $scope.removeUploadedFile){
                            //This is when we hit delete just after uploading a file .You want to keep the panel open.

                            $scope.file.showUploadPanel = true;
                        }
                        $scope.flags.pdfLoading = false;
                        $scope.setPreview();
                    }
                    $scope.createPreviewUrl($scope.file);
                    $scope.setPreview();

                }

            };

            $scope.atchmntModel.postFetch = function(){
                if(!$.isEmptyObject($scope.attachmentResponse)){
                    $scope.attachment[$scope.attachmentIndex] = $scope.attachmentResponse.resourceInfo;
                    if($scope.attachmentResponse.attachmentInfo){
                        $scope.attachment.info = $scope.attachmentResponse.attachmentInfo;
                    }
                }

                if($scope.file && $scope.file.fileKind === 'Attachment'){
                    if($.isEmptyObject($scope.attachmentResponse)){
                        $scope.file = $scope.attachment[$scope.attachmentIndex] = {};
                        $scope.file.fileKind = 'Attachment';
                        $scope.file.kind = 'Portfolio';
                        $scope.file.fileType = i18n.ATTACHMENT;

                        if($scope.expandUpload && $scope.removeUploadedFile){
                            //This is when we hit delete just after uploading a file .You want to keep the panel open.

                            $scope.file.showUploadPanel = true;
                        }
                        $scope.file.empty = true;
                        return;
                    }
                    $scope.attachment[$scope.attachmentIndex] = $scope.attachmentResponse.resourceInfo;
                    //populating the attachment names in the list
                    if($scope.attachmentResponse.attachmentInfo){
                        $scope.attachment.info = $scope.attachmentResponse.attachmentInfo;
                    }

                    if(!$scope.fetchOnLoad){
                        $scope.file = $scope.attachment[$scope.attachmentIndex];
                        $scope.file.fileKind = 'Attachment';
                        $scope.file.kind = 'Portfolio';
                        $scope.file.fileType = i18n.ATTACHMENT;
                    }


                    if($scope.expandUpload && $scope.removeUploadedFile){
                        //This is when we hit delete just after uploading a file .You want to keep the panel open.

                        $scope.file.showUploadPanel = true;
                    }
                    $scope.setPreview();
                }
            };


            $scope.fetchOnLoad = true;
            $scope.flags.loading = true;

            var finishInitialLoad = function(){
                $scope.fetchOnLoad = false;
            };

            $scope.$watch('resume',function(newVal){
                if(newVal && !$.isEmptyObject(newVal)){
                    finishInitialLoad();
                }
            });
            // Only loads on body onload when its not view form flow from workflow tab.
            if(!$scope.$parent.viewFormFlow && $scope.perms.APPLICATION_RESOURCE_GET){
                //Fetching Attachments on click of application tab to show the attachment count
                $scope.atchmntModel.fetch({
                url: $scope.requestUrls.applicationDetail + $scope.params.applicationId + '/resource/' + $scope.kindMapping['Attachment'],
                    destkey: 'attachmentResponse',
                    data: {
                        readMode: 0
                    }
                });

                // Fetching cover letter on click of the Application tab
                $scope.clModel.fetch({
                    url: $scope.requestUrls.applicationDetail + $scope.params.applicationId + '/resource/' + $scope.kindMapping['CoverLetter'],
                    sourceKey: 'resourceInfo',
                    destkey: 'coverletter',
                    data: {
                        readMode: 0
                    }
                });
            }
            // Resume is the default file type. $scope.file = 'Resume'; PDF view as default
            if($scope.perms.PREINTERVIEW_FORM_GET) {
                candidates.getCandApplicationForm($scope.params.applicationId, function(res){
                    $scope.candApplicationFormsRes = {};
                    $scope.candApplicationFormsRes.forms = res.candidateAppForms;
                    function processSectionsWithChoices(jsonSections) {
                        angular.forEach(jsonSections, function(section) {
                            angular.forEach(section.element, function(element) {
                                if (element && typeof element === 'object') {
                                    element.required = (Number(element.flags) % 2) !== 0;
                                }
                                if (element.choices && angular.isDefined(element.value)) {
                                    var newItems = [],
                                    validChoices = element.value.split('\n');
                                    angular.forEach(element.choices.item, function(item) {
                                        if(validChoices.indexOf(item.name) > -1) {
                                            newItems.push(item);
                                        }
                                    });
                                    element.choices.item = newItems;
                                }
                            });
                        });
                    }

                    if($scope.candApplicationFormsRes.forms){
                        for(var j=0; j<$scope.candApplicationFormsRes.forms.length; j++){
                            if($scope.candApplicationFormsRes.forms[j] && !$scope.candApplicationFormsRes.forms[j].completed)
                            {
                                $scope.candApplicationFormsRes.forms.splice(j,1);
                                j--;
                            }
                        }

                        for(var i=0; i<$scope.candApplicationFormsRes.forms.length; i++){
                            //Bug https://bugzilla.aws.jobvite.com/show_bug.cgi?id=22431 . Removing certain special chars as it prevents the form from being rendered. NV
                            var specialChars = ['&#x[0-9];','&#xC;','&#xB;'];
                            var specialChar = specialChars.join('|');
                            var regEx = new RegExp(specialChar,'g');
                            $scope.candApplicationFormsRes.forms[i].content  = $scope.candApplicationFormsRes.forms[i].content.replace(regEx,'');
                            var shortcutToJson = $scope.candApplicationFormsRes.forms[i].json = $.xml2json($scope.candApplicationFormsRes.forms[i].content);
                            if(angular.isArray(shortcutToJson.section)){
                                processSectionsWithChoices(shortcutToJson.section);
                            }
                          else{
                                processSectionsWithChoices([shortcutToJson.section]);
                             }
                        }
                        angular.extend($scope.addFormInfo,{
                            'requistionName': res.requisitionInfo.title,
                            'requistionId':res.requisitionInfo.requisitionId
                        });
                        $scope.formFunctions($scope.candApplicationFormsRes);
                        /*
                         * View form flow from workflow Tab
                         */
                        if($scope.$parent.viewFormFlow){
                            $scope.$parent.viewFormFlow = false;
                            $scope.jumpTo('Forms', 0);
                            // Looping through to find out the index of the form and then expand. Only First form of inviteForms will be expanded.
                            angular.forEach($scope.preInterviewForm.forms, function(form, index){
                                if($scope.$parent.inviteForms && $scope.$parent.inviteForms[0].item1EId === form.item1EId){
                                    $scope.showAppForm(index);
                                }
                            });
                        }
                    }else{
                        $scope.flags.loading = false;
                    }

                }, function(){
                    $scope.flags.loading = false;
                });
            }


            $scope.addPost = function(){
                $scope.flags.quickForms = 'post';
                $scope.showQForm('post');
            };

            $scope.showSocialProfile = false;
            // Only loads on body onload when its not view form flow from workflow tab.
            if(!$scope.$parent.viewFormFlow && $scope.perms.APPLICATION_SOCIAL_PROFILE){
                candidates.fetchSocialProfile($scope.params,function(response, code){
                    var facebookProfileLink = '//www.facebook.com/';

                    if(code === 200 && response){
                        if(!$.isEmptyObject(response)){
                            $scope.showSocialProfile = true;
                            if(response.Facebook){
                                $scope.fbProfile = response.Facebook;
                                // Set the Facebook link to the users timeline
                                $scope.fbProfile.profileLink = facebookProfileLink + response.Facebook.socialId;
                            }
                            if(response.LinkedIn){
                                if(response.LinkedIn.workHistory){
                                    angular.forEach(response.LinkedIn.workHistory,function(job){
                                        if(job.endMonth === 0 && job.endYear=== 0){
                                            job.totalMonth = $rootScope.dateDiff(new Date(job.startYear, job.startMonth),new Date(),'months');
                                        }
                                    });
                                }

                                $scope.liProfile = response.LinkedIn;
                            }
                        }
                    }
                });
            }


            $scope.preview = 'pdf';

            $scope.resumeModel = jvCandResumeModelFactory($scope, 'resume');

            $scope.uploadSave = function(){
                if($scope.expandTextArea){
                    if($scope.textarea.fileContent){
                        $scope.resourceInfo.content = $scope.textarea.fileContent;
                    }else{
                        $scope.resourceInfo.content = '';
                    }
                    delete $scope.resourceInfo.fId;
                }
                if($scope.file.fileKind === 'Attachment'){
                    $scope.resourceInfo.fId = [];
                    angular.forEach($scope.attachment.files,function(resource,fileEid){
                        $scope.resourceInfo.fId.push(fileEid);
                        $scope.resourceInfo.content = resource.resourceInfo.fileContent;
                    });
                }else if($scope.file.fileKind === 'Resume'){
                    angular.forEach($scope.resume.files,function(resource,fileEid){
                        $scope.resourceInfo.fId = fileEid;
                        $scope.resourceInfo.content = resource.resourceInfo.fileContent;
                    });
                }else{
                    angular.forEach($scope.coverletter.files,function(resource,fileEid){
                        $scope.resourceInfo.fId = fileEid;
                        $scope.resourceInfo.content = resource.resourceInfo.fileContent;
                    });
                }
                $scope.removeUploadedFile = false;
                $scope.resourceInfo.kind = $scope.kindMapping[$scope.file.fileKind];
                $scope.resourceInfo.applicationId = $scope.params.applicationId;
                $scope.resumeModel.saveUploadContent($scope.resourceInfo);
                //resModel.getPDFResources($scope.resourceInfo);

            };

            $scope.getClickedAttachment = function(fileId,fileName){
                $scope.resumeModel.fetchClickedAttachment($scope.params.applicationId, fileId, fileName);
            };

            $scope.showPreview = function(){

                    $scope.preview = 'pdf';
                    $scope.file.showUploadPanel = false;
                    if($scope.file.eid){
                        $scope.pdfUrl = $scope.requestUrls.resource + $scope.params.applicationId + '/file/' + $scope.file.eid+ '?preview=true&fName=jobvite.pdf&kind='+$scope.file.kind+'#zoom=100';
                    }
                    $rootScope.$emit('PdfPreviewOn');

            };
            $scope.isPDF=function(fileName){
                return (/\.(pdf)$/ig).test(fileName);
            };
            //flag to make sure text is not replaced more than once
            $scope.textReplaced = false;
            $scope.showText = function(){
                //replacing new line with br so that content renders correctly on all browsers
                var regex = new RegExp(/[\n\r]/g);
                if(regex.test($scope.file.fileContent) && !$scope.textReplaced){
                    $scope.file.fileContent  = ($('<div></div>').text($scope.file.fileContent).html()).replace(/\n/g, '<br/>');
                    $scope.textReplaced = true;
                }
                else if(angular.isUndefined($scope.file.fileContent) || $scope.file.fileContent === 'null') {
                    $scope.file.fileContent  = ($('<div></div>').text(i18n.RESUME_TEXT_VIEW_UNAVAILABLE).html());
                    $scope.textReplaced = true;
                }
                $scope.preview = 'text';
                $scope.file.showUploadPanel = false;
                $scope.pdfUrl = '';
            };

            $scope.showHtml = function(){
                $scope.filePreview = $scope.filePreview || {};
                $scope.preview = 'html';
            };

            $scope.setPreview = function(){
                $scope.showHtml();
            };

            $scope.showMaskedView = function(){
                $scope.preview = 'masked';
                $scope.filePreview = $scope.filePreview || {};
                $scope.filePreview.maskedUrl = $scope.requestUrls.resource + $scope.params.applicationId + '/file/' + $scope.file.eid+ '/mask?preview=true';
            };

           $scope.uploadNewFile = function (){

                if($scope[$scope.file.fileKind].Uploader){
                    $scope[$scope.file.fileKind].Uploader = false;
                }
                $scope[$scope.file.fileKind].Uploader = true;

                if ($scope.file.fileSize && $scope.file.fileKind !== 'Attachment'){
                    var cancel = function(){
                        $scope.$root.modal.show = false;
                    };
                    $scope.$root.modal = {
                        show:true,
                        buttons: [
                                  {
                                      label: i18n['JV_CAND_DETAILS_RESUME_REPLACE'],
                                      title: 'Replace',
                                      click: function(){
                                          $scope.$root.modal.show = false;
                                          $scope.file.showUploadPanel=true;
                                          $scope.expandUpload = true;
                                          $scope.uploaderClass = 'actn-collapse';
                                          $scope.expandTextArea = false;
                                          $scope.textareaClass = 'actn-expand';
                                          $scope.fileUploaded = false;
                                      }
                                  },
                                  {
                                      'label': i18n['CANCEL'],
                                      'title': 'Cancel',
                                      'click': cancel,
                                      'class': 'cancel'
                                  }
                        ],
                        cancel: cancel,
                        title: i18n['JV_CAND_DETAILS_RESUME_REPLACE_FILE'],
                        body: i18n['JV_CAND_DETAILS_RESUME_ARE_YOU_SURE_YOU_WANT_TO_REPLACE_THIS_FILE_']
                    };
                }else{
                    $scope.$root.modal.show = false;
                    $scope.file.showUploadPanel=true;
                    $scope.expandUpload = true;
                    $scope.uploaderClass = 'actn-collapse';
                    $scope.expandTextArea = false;
                    $scope.textareaClass = 'actn-expand';
                    $scope.fileUploaded = false;
                }
            };

            $scope.expandUploader = function(){
                if($scope.expandUpload){
                    $scope.expandUpload = false;
                    $scope.uploaderClass = 'actn-expand';
                }else{
                    $scope.expandUpload = true;
                    $scope.uploaderClass = 'actn-collapse';
                    $scope.expandTextArea = false;
                    $scope.textareaClass = 'actn-expand';
                }
            };

            $scope.expandText = function(){
                if($scope.expandTextArea){
                    $scope.expandTextArea = false;
                    $scope.textareaClass = 'actn-expand';
                }else{
                    $scope.expandUpload = false;
                    $scope.uploaderClass = 'actn-expand';
                    $scope.expandTextArea = true;
                    $scope.textareaClass = 'actn-collapse';
                }
                $scope.errors = {};
            };


            /*
             * Temporary function to switch between types. After polishing the model, the switch should go out completely
             * or atleast look a lot less verbose.
             * WIP
             */
            $scope.jumpTo = function(fileType, attachmentIndex) {  // eslint-disable-line
                // A weird hack to fix http://stackoverflow.com/questions/10366867/object-tag-doesnt-refresh-when-its-data-attribute-is-changed-in-chrome
                $timeout(function(){
                    $('body').trigger('click');
                },100);
                switch(fileType){
                    case 'Resume':
                        $scope.jump = 'file';
                        if(!$scope.resume || $.isEmptyObject($scope.resume)){
                            $scope.fastRead = true;
                            $scope.resModel.fetch({
                                url: $scope.requestUrls.applicationDetail + $scope.params.applicationId + '/resource/' + $scope.kindMapping['Resume'],
                                sourceKey: 'resourceInfo',
                                destkey: 'resume',
                                data: {
                                    readMode: 0
                                }
                            });
                        }else{
                            $scope.file = $scope.resume;
                            $scope.file.fileType = i18n.RESUME;

                            $scope.file.fileKind = 'Resume';
                            $scope.file.kind = 'Resume';
                            $scope.file.readMode = 1;
                            $scope.createPreviewUrl($scope.file);
                            $scope.setPreview();
                            if($scope.file.eid){
                                $scope.pdfUrl = $scope.requestUrls.resource + $scope.params.applicationId + '/file/' + $scope.file.eid + '?preview=true&fName=jobvite.pdf#zoom=100';
                            }
                        }
                        //$scope.file = $scope.resume;
                        break;

                    case 'CoverLetter':
                        $scope.jump = 'file';
                        if(!$scope.coverletter || $.isEmptyObject($scope.coverletter)){
                            $scope.fastRead = true;
                            $scope.clModel.fetch({
                                url: $scope.requestUrls.applicationDetail + $scope.params.applicationId + '/resource/' + $scope.kindMapping['CoverLetter'],
                                sourceKey: 'resourceInfo',
                                destkey: 'coverletter',
                                data: {
                                    readMode: 0
                                }
                            });

                        }else{
                            $scope.file = $scope.coverletter;
                            $scope.file.fileKind = 'CoverLetter';
                            $scope.file.kind = 'CoverLetter';
                            $scope.file.fileType = i18n.COVERLETTER;
                            $scope.file.readMode = 1;
                            $scope.createPreviewUrl($scope.file);
                            $scope.setPreview();
                            $scope.clModel.postFetch();
                        }

                        //$scope.file = $scope.coverletter;
                        break;

                    case 'Attachment':
                        $scope.jump = 'file';
                        $scope.file = {};
                        $scope.file.fileKind = 'Attachment';
                        $scope.file.kind = 'Portfolio';
                        if(!$scope.attachment[$scope.attachmentIndex] || $.isEmptyObject($scope.attachment)){
                            $scope.atchmntModel.fetch({
                                url: $scope.requestUrls.applicationDetail + $scope.params.applicationId + '/resource/' + $scope.kindMapping['Attachment'],
                                destkey: 'attachmentResponse',
                                data: {
                                    readMode: 0
                                }
                            });
                            $scope.removeUploadedFile = false;
                        }else{
                            $scope.file = $scope.attachment[$scope.attachmentIndex];
                            $scope.file.fileKind = 'Attachment';
                            $scope.file.kind = 'Portfolio';
                            $scope.file.fileType = i18n.ATTACHMENT;
                            if($scope.file.empty) {
                                $scope.file.fileSize = 0;
                            }
                        }
                        $scope.setPreview();

                        //$scope.file = $scope.attachment[index];
                        break;

                    case 'Forms':
                        $scope.file.fileKind = 'Forms';
                        $scope.jump = 'forms';
                        if($scope.preInterviewForm && $scope.preInterviewForm.forms.length > 0){
                            for(var i=0; i<$scope.preInterviewForm.forms.length; i++){
                                if(i === 0){
                                    $scope.preInterviewForm.index = 0;
                                    $scope.preInterviewForm.forms[i].show = true;
                                    $scope.preInterviewForm.forms[i].expanded = true;
                                }
                                else
                                {
                                    $scope.preInterviewForm.forms[i].show = false;
                                    $scope.preInterviewForm.forms[i].expanded = false;
                                }
                            }
                        }
                        if(!$scope.addFormInfo.imageURL){
                            candidates.getCompanyLogo(function(response){
                                if(response && response.fetchImageResult && response.fetchImageResult.model && response.fetchImageResult.model.imageURL){
                                    $scope.addFormInfo.imageURL=response.fetchImageResult.model.imageURL;
                                }
                            });
                        }
                        $scope.addFormInfo.candidateName = $scope.appDetails.application.candidate.firstName+' '+$scope.appDetails.application.candidate.lastName;
                        break;

                    case 'Social':
                        $scope.jump = 'social';
                        $scope.file.fileKind = 'social';

                        break;
                    case 'Videos':
                        $scope.jump = 'Videos';
                        $scope.file.fileKind = 'videos';
                        break;
                    default:
                        break;
                }
            };


            $scope.showAppForm = function(index){
                $scope.preInterviewForm.index = index;
                if($scope.preInterviewForm.forms){
                    for(var i=0; i<$scope.preInterviewForm.forms.length; i++){
                        if(i === index){
                            $scope.preInterviewForm.forms[i].expanded = true;
                            $scope.preInterviewForm.forms[i].show = true;
                        }
                        else
                        {
                            $scope.preInterviewForm.forms[i].expanded = false;
                            $scope.preInterviewForm.forms[i].show = false;
                        }
                    }
                }
            };

            // Setting the file type on load.
            $scope.file = $scope.resume || {};
            if($scope.$parent.viewFormFlow){
                $scope.file ['fileKind'] = 'Forms';
                $scope.jump = 'forms';
            }else{
                $scope.jump = 'file';
            }

            $scope.deleteFile = function(file){
                if(file){
                    $scope.fileToDelete = file.eid;
                }
                // Modal displayed when user tries to delete a file.
                $scope.$root.modal = {
                    show:false,
                    buttons: [{
                                label: i18n['JV_CAND_DETAILS_RESUME_DELETE'],
                                title: 'Delete',
                                click: function(){
                                    // Delete the file
                                        var data= {
                                            applicationId: $scope.params.applicationId,
                                            fId: ($scope.file.eid || $scope.fileToDelete),
                                            fKind: $scope.kindMapping[$scope.file.fileKind]
                                        };

                                        candidates.deleteApplicationResource(data, function(){
                                            $scope.$root.modal.show = false;
                                            var type = $scope.file.fileKind.toLowerCase();
                                            $scope.fileUploaded = false;
                                            $scope[type] = {};
                                            $scope.showMsg('FILE_DELETED');
                                            if($scope.file.fileKind === 'Attachment') {
                                                $scope.jumpTo($scope.file.fileKind,0);
                                            }
                                            else {
                                                $scope.jumpTo($scope.file.fileKind);
                                            }
                                        });
                                    }
                                },
                                {
                                    label: i18n['JV_CAND_DETAILS_RESUME_CANCEL'],
                                    title: 'Cancel',
                                    click: function(){
                                        $scope.$root.modal.show = false;
                                    },
                                    'class': 'cancel'
                                }
                    ],
                    cancel: function(){
                        this.show = false;
                    },
                    title: i18n['JV_CAND_DETAILS_RESUME_DELETE_FILE'],
                    body: i18n['JV_CAND_DETAILS_RESUME_ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_FILE_']
                };
                $scope.modal.show = true;
            };

            $scope.downloadFile = function(){
                $scope.downloadFileParams={
                    url: $scope.requestUrls.resource + $scope.params.applicationId + '/file/' + $scope.file.eid,
                    data:{},
                    success: function(){
                        //success
                    }
                };
                $scope.resModel.fetch($scope.downloadFileParams);
            };

            $scope.downloadAttachment = function(appEId, fileEId, name, kind){
                if(fileEId && name){
                    var isWindowsBrowser = browserDetails.getOSVersion()==='Windows';
                    window.open($scope.requestUrls.resource + appEId + '/file/' + fileEId+'?isWindows='+isWindowsBrowser+'&kind='+kind, '_blank');
                }
            };

            $scope.downloadMaskedResume = function(appEId, fileEId, name, kind){
                 if(fileEId && name){
                     var isWindowsBrowser = browserDetails.getOSVersion()==='Windows';
                     window.open($scope.requestUrls.resource + appEId + '/file/' + fileEId+'/mask?preview=false&isWindows='+isWindowsBrowser+'&kind='+kind, '_blank');
                 }
            };

            $scope.onFileTimeout = function(){

                    $scope.$emit('Fileloaded',true);
                    $timeout.cancel($scope.filePopoutTimer);
                    $scope.filePopoutTimer = $timeout($scope.onFileTimeout,100);
            };

            $scope.$watch('stopFilePolling',function(newVal){
                    if(newVal){
                        $timeout.cancel($scope.filePopoutTimer);
                        $scope.stopFilePolling = false;
                    }
            });


            $scope.popout = function (popType,type,index,preview){
                var w = 1200;
                var h = 700;
                var x = screen.width/2 - (w/2);
                var y = screen.height/2 - (h/2);
                var randomnumber = Math.floor(Math.random()*101);
                // eslint-disable-next-line
                var previewWindow;
                window.$windowScope = $scope;


                $scope.processedInterviewForm = JSON.stringify(angular.copy($scope.preInterviewForm));
                $scope.windowName = 'previewWindow'+randomnumber;
                $scope.fileType = type;
                $scope.fileIndex = index;
                $scope.popoutpreview = preview;

                if(popType==='Popout'){
                    if(type==='Resume' || type==='CoverLetter'){
                        previewWindow = window.open('../candidates/details/application/filesPopout.html?applicationId='+$scope.params.applicationId+'&fId='+$scope.file.eid+'&fName='+$scope.file.fileName,$scope.windowName,'width='+w+',height='+h+',left='+x+',top='+y+',scrollbars=yes');
                    }
                    else if(type==='Forms'){
                        previewWindow = window.open('../candidates/details/application/filesPopout.html?applicationId='+$scope.params.applicationId+'&fId='+$scope.file.eid,$scope.windowName,'width='+w+',height='+h+',left='+x+',top='+y+',scrollbars=yes');
                    }

                    $scope.onFileTimeout();
                    //$scope.filePopoutTimer = $timeout($scope.onFileTimeout,100);
                }
                else if(popType==='Print'){
                     var data = {};
                     data.processedInterviewForm = JSON.stringify(angular.copy($scope.preInterviewForm));
                      data.windowName = $scope.windowName;
                      data.fileType = type;
                      data.fileIndex = index;
                      data.popoutpreview = preview;
                      data.addFormInfo = $scope.addFormInfo;
                      $localStorage.printFormData = data;
                    if(type==='Resume') {
                        data.resume= $scope.resume ;
                        // eslint-disable-next-line
                        previewWindow = window.open($scope.requestUrls.popUpFiles + 'printFiles.html?applicationId='+$scope.params.applicationId+'&fId='+$scope.file.eid+'&fName='+$scope.file.fileName,$scope.windowName,'width='+w+',height='+h+',left='+x+',top='+y+',scrollbars=yes');

                    } else if(type==='CoverLetter'){
                         data.coverletter= $scope.coverletter ;
                         // eslint-disable-next-line
                         previewWindow = window.open($scope.requestUrls.popUpFiles + 'printFiles.html?applicationId='+$scope.params.applicationId+'&fId='+$scope.file.eid+'&fName='+$scope.file.fileName,$scope.windowName,'width='+w+',height='+h+',left='+x+',top='+y+',scrollbars=yes');
                    } else if(type==='Forms'){
                        data.resume= $scope.resume;
                        // eslint-disable-next-line
                        previewWindow = window.open($scope.requestUrls.popUpFiles + 'printFiles.html?applicationId='+$scope.params.applicationId+'&fId='+$scope.file.eid,$scope.windowName,'width='+w+',height='+h+',left='+x+',top='+y+',scrollbars=yes');
                    }                }
                return false;//needed so that the parent page doesn't refresh
            };

            $scope.togglePreIntForm = function(form){
                form.show = !form.show;
            };

            $scope.flags.loading = false;
    }]);